<script setup lang="ts">
const props = defineProps<{
	row: any
	objectModal?: any
}>()
</script>

<template>
	<div v-if="row.tx_at?.$date">
		<div class="text-zinc-800 dark:text-zinc-300">{{ $dayjs(row.tx_at?.$date).fromNow() }}</div>
		<div>{{ $dayjs(row.tx_at?.$date).format('L, LT') }}</div>
	</div>
	<div v-else>
		<div class="text-zinc-800 dark:text-zinc-300">{{ $dayjs(row.created_at?.$date).fromNow() }}</div>
		<div>{{ $dayjs(row.created_at?.$date).format('L, LT') }}</div>
	</div>
	<UButton
		v-if="objectModal"
		size="xs"
		color="gray"
		variant="ghost"
		@click="objectModal?.show(row)"
		icon="i-material-symbols-data-object-rounded"
	/>
</template>
